var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.492 16.237L18.7 17.9C18.9484 18.0863 19.15 18.3279 19.2889 18.6056C19.4277 18.8833 19.5 19.1895 19.5 19.5V20.5H11.5V19.5C11.5 19.1895 11.5723 18.8833 11.7111 18.6056C11.85 18.3279 12.0516 18.0863 12.3 17.9L14.508 16.237",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.5C17.5 12.3954 16.6046 11.5 15.5 11.5C14.3954 11.5 13.5 12.3954 13.5 13.5V14.5C13.5 15.6046 14.3954 16.5 15.5 16.5C16.6046 16.5 17.5 15.6046 17.5 14.5V13.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5H22.5C23.0304 5.5 23.5391 5.71071 23.9142 6.08579C24.2893 6.46086 24.5 6.96957 24.5 7.5V25.5C24.5 26.0304 24.2893 26.5391 23.9142 26.9142C23.5391 27.2893 23.0304 27.5 22.5 27.5H6.5V5.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9.5V13.5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmContacts);
export default __webpack_public_path__ + "static/media/BMContacts.f3cf0ef349450ec5c4d24e3434c77bfd.svg";
export { ForwardRef as ReactComponent };